import { Directive, OnInit, ElementRef } from '@angular/core';

@Directive({
    selector: '[my-auto-focus]'
})
export class AutofocusDirective implements OnInit {

    constructor(private elementRef: ElementRef) { };

    ngOnInit(): void {
        let element = this.elementRef.nativeElement;
        setTimeout( () =>{
            element.focus();
        },500)

   }

}